"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
// 排序資料並將可以辨識是否唯一的資料加入 dataId
function getItemDataId(item) {
    var _a;
    let dataId = item.menuId;
    lodash_1.default.orderBy(item.options, ['optionId', 'asc'])
        .forEach(option => {
        dataId += option.optionId + String(option.quantity);
    });
    lodash_1.default.orderBy(item.tags, ['name', 'asc'])
        .forEach(tag => {
        dataId += tag.name;
    });
    lodash_1.default.orderBy(item.modifiers, ['optionId', 'asc']) // FIXME: modifiers 應該沒有 optionId
        .forEach(modifier => {
        dataId += String(modifier.id) + String(modifier.percent) + String(modifier.amount);
    });
    dataId += item.remarks[0];
    (_a = item.setItems) === null || _a === void 0 ? void 0 : _a.map(getItemDataId).forEach(setItemDataId => {
        dataId += setItemDataId;
    });
    return dataId;
}
exports.default = getItemDataId;
//# sourceMappingURL=getItemDataId.js.map